export default __webpack_public_path__ + "static/media/preview-pure-media.717116f7.jpg";